/*
Copyright (c) 2021
*/

import actions from '../../actions';
// reducer with initial state
const initialState = {
    EditRespondantDataGenPool: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.EditRespondantDataGenPoolAction.requestEditResearcherGenPoolData:
      return {
        ...state
      };
    case actions.EditRespondantDataGenPoolAction.EditResearcherGenPoolDataReceived:
      return {
        ...state,
        EditRespondantDataGenPool: action.data
      };

    default:
      return state;
  }
};

export default reducer;
